import React, { useState } from 'react';
import {
  Modal, ModalBody, ModalHeader, FormGroup, Button, Row, Col, Label,Input,
} from 'reactstrap';
import LaddaButton, { EXPAND_RIGHT } from 'react-ladda';
import PropTypes from 'prop-types';


const ModalComments = ({
  open, id, fromDate, toDate, toggle, account, onboardingid, person, services, setRedirectPerson, newOnboardingVersion
}) => {
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(undefined);
  const [topic, setTopic] = useState('All');
  const [comment, setComment] = useState('');

  const handleChangeDate = (name, value) => {
    if (name === 'from') {
      setFrom(value);
    } else {
      setTo(value);
    }
  };

  const handleChangeComment = (text) => {
    setComment(text)
  };

  const handleResponse = (response) => {
    if (response && response.result && response.result.Code){
    setLoading(false);
    toggle();
    }
  };

  const handleClose = () => {
    setFile(undefined);
    setLoading(false);
    toggle();
  };

  const handleComment = () => {
    setLoading(true);
  
    if (newOnboardingVersion) {
      const body = {
        personId: person.PersonId,
        description: comment,
        reject: true,
      };
  
      services.fetchOnboardingPersonHistory(body, (response) => {
        if (response && response.result && response.result.Code === 200) {
          setLoading(false);
          toggle();
          setRedirectPerson(person.PersonId);
        } else {
          setLoading(false); 
        }
      });
    } else {
      const body = {
        onboardingid: person.PersonId,
        description: comment,
        reject: true,
      };
  
      services.fetchOnboardingHistory(body, (response) => {
        if (response && response.result && response.result.Code === 200) {
          setLoading(false);
          toggle();
          setRedirectPerson(person.PersonId);
        } else {
          setLoading(false);
        }
      });
    }
  };
  
  return (
    <Modal toggle={handleClose} isOpen={open} person={person}>
      <ModalHeader toggle={handleClose}>
      {`Set ${person && person.PersonName} comment`}
      </ModalHeader>
      <ModalBody>
        <FormGroup>
          <Row>
            <Col>
            <FormGroup >
                <Label >Comment</Label>
                <Input 
                    onChange={(e) => handleChangeComment(e.target.value)}
                    type="textarea" 
                    required
                    name="Comment" 
                    defaultValue = {comment} >
                </Input>                              
            </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <LaddaButton
                className="btn btn-ladda btn-primary"
                loading={loading}

                onClick={handleComment}
                data-style={EXPAND_RIGHT}
              >
                <i className="fa fa-upload" />
                {loading ? ' Saving' : ' Save'}
              </LaddaButton>
            </Col>
          </Row>
        </FormGroup>
      </ModalBody>
    </Modal>
  );
};

ModalComments.propTypes = {
  open: PropTypes.bool.isRequired,
  id: PropTypes.oneOf([PropTypes.string.isRequired, PropTypes.number.isRequired]).isRequired,
  fromDate: PropTypes.object.isRequired,
  toDate: PropTypes.object.isRequired,
  toggle: PropTypes.func.isRequired,
  account: PropTypes.bool.isRequired,
  person: PropTypes.object.isRequired,
};

export default ModalComments;
